import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePreorderEnabled } from '../../hooks/usePreorderEnabled';
import CategoriesManagement from './CategoriesManagement';

const CategoriesManagementGuard: React.FC = () => {
  const { enabledNewVersion } = usePreorderEnabled();

  if (!enabledNewVersion) {
    return <Navigate to="/order_history" replace />;
  }

  return <CategoriesManagement />;
};

export default CategoriesManagementGuard;
